// Bottom sheet built on RN's Modal (works on iOS, Android, web/Telegram). No gesture or
// spring animation libraries: the platform's simple slide/fade is enough.
import React from 'react';
import { KeyboardAvoidingView, Modal, Platform, Pressable, ScrollView, Text, View, useWindowDimensions } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { IconButton } from './ui';
import { font, radius, spacing, usePalette } from '../theme';
import { useTranslation } from 'react-i18next';

export default function Sheet({
  visible, onClose, title, children, right, full,
}: { visible: boolean; onClose: () => void; title?: string; children: React.ReactNode; right?: React.ReactNode; full?: boolean }) {
  const p = usePalette();
  const { t } = useTranslation();
  const insets = useSafeAreaInsets();
  const { height, width } = useWindowDimensions();
  const wide = width >= 700;
  return (
    <Modal visible={visible} transparent animationType={Platform.OS === 'web' ? 'fade' : 'slide'} onRequestClose={onClose} statusBarTranslucent>
      <KeyboardAvoidingView behavior={Platform.OS === 'ios' ? 'padding' : undefined} style={{ flex: 1, justifyContent: wide ? 'center' : 'flex-end', alignItems: 'center', backgroundColor: p.overlay }}>
        <Pressable accessibilityLabel={t('common.close')} onPress={onClose} style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0 }} />
        <View
          style={{
            width: wide ? Math.min(560, width - 48) : '100%',
            maxHeight: height * (full ? 0.95 : 0.85),
            minHeight: full ? height * 0.6 : undefined,
            backgroundColor: p.background,
            borderTopLeftRadius: radius.l * 1.5, borderTopRightRadius: radius.l * 1.5,
            borderBottomLeftRadius: wide ? radius.l * 1.5 : 0, borderBottomRightRadius: wide ? radius.l * 1.5 : 0,
            paddingBottom: wide ? spacing.l : insets.bottom + spacing.s,
          }}>
          <View style={{ flexDirection: 'row', alignItems: 'center', paddingHorizontal: spacing.l, paddingTop: spacing.m, paddingBottom: spacing.s, gap: spacing.s }}>
            <Text style={{ flex: 1, fontSize: font.headline, fontWeight: '700', color: p.text }} numberOfLines={1}>{title}</Text>
            {right}
            <IconButton icon="close" label={t('common.close')} onPress={onClose} />
          </View>
          <ScrollView contentContainerStyle={{ paddingHorizontal: spacing.l, paddingBottom: spacing.l, gap: spacing.m }} keyboardShouldPersistTaps="handled">
            {children}
          </ScrollView>
        </View>
      </KeyboardAvoidingView>
    </Modal>
  );
}
